"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var icelandicNumberLocaleWorkaroundChrome = function (value, intl, options) {
    var locale = localStorage.getItem("languageString");
    if (locale) {
        var supportedLocalesArray = Intl.NumberFormat.supportedLocalesOf(locale);
        if (supportedLocalesArray.every(function (x) { return x !== locale; })) {
            switch (locale) {
                case "is":
                    if (options) {
                        switch (options.style) {
                            case "decimal": {
                                return convertToIcelandicThousandAndDecimalSeparator(value.toFixed(2));
                            }
                            case "currency": {
                                if (!options.currency) {
                                    throw new Error("options.currency must be specified if options.style = 'currency'");
                                }
                                var roundedValue = convertToIcelandicThousandAndDecimalSeparator(Math.round(value).toString());
                                var suffix = " " + options.currency;
                                return roundedValue + suffix;
                            }
                            case "percent": {
                                var roundedValue = convertToIcelandicThousandAndDecimalSeparator(value.toString());
                                var suffix = " %";
                                return roundedValue + suffix;
                            }
                            case "unit": {
                                return convertToIcelandicThousandAndDecimalSeparator(value.toString());
                            }
                        }
                    }
                    return convertToIcelandicThousandAndDecimalSeparator(value.toString());
                default:
                    return intl.formatNumber(value, options);
            }
        }
    }
    return intl.formatNumber(value, options);
};
exports.icelandicNumberLocaleWorkaroundChrome = icelandicNumberLocaleWorkaroundChrome;
var convertToIcelandicThousandAndDecimalSeparator = function (value) {
    var parts = value.split(".");
    return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".") + (parts[1] ? "," + parts[1] : ",00");
};
var returnDecimalSeparatorForLocale = function (locale) {
    switch (locale) {
        case "is":
            return ",";
        default:
            return undefined;
    }
};
exports.returnDecimalSeparatorForLocale = returnDecimalSeparatorForLocale;
